import { Component, Input } from '@angular/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';

@Component({
  selector: 'vfs-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent {
  @Input() color: string = 'accent';
  @Input() mode: ProgressSpinnerMode = 'indeterminate';
  @Input() value = 50;
  @Input() diameter = 90;
  @Input() strokeWidth = 8;
}
